import { render, staticRenderFns } from "./After.vue?vue&type=template&id=f6d170ec&scoped=true&"
import script from "./After.vue?vue&type=script&lang=js&"
export * from "./After.vue?vue&type=script&lang=js&"
import style0 from "./After.vue?vue&type=style&index=0&id=f6d170ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d170ec",
  null
  
)

export default component.exports